import { Button, Checkbox, Icon, TableCell, TableRow } from "semantic-ui-react";
import { DataTable } from "../../ui";

export const TeamMembersTable = ({
  teamMembers,
  isLoading,
  handleToggleSupervisor,
  handleRemoveUser,
}) => {
  return (
    <DataTable
      columns={[
        { key: "name", label: "Name", width: 12 },
        { key: "supervisor", label: "Supervisor", width: 2, align: "center" },
        { key: "actions", label: "", width: 2, align: "center" },
      ]}
    >
      {teamMembers?.map((member) => {
        return (
          <TableRow key={member.id}>
            <TableCell>{member.name}</TableCell>
            <TableCell textAlign="center">
              <Checkbox
                toggle
                checked={member.supervisor}
                onChange={() => handleToggleSupervisor(member.id)}
                disabled={isLoading}
              />
            </TableCell>
            <TableCell textAlign="right">
              <Button
                icon
                color="red"
                onClick={() => handleRemoveUser(member)}
                disabled={isLoading || teamMembers.length <= 1}
              >
                <Icon name="user delete" inverted />
              </Button>
            </TableCell>
          </TableRow>
        );
      })}
    </DataTable>
  );
};
